<template>
  <div>
    <v-btn
      @click="dialog = true"
      class="primary"
      style="cursor: help"
      title="Análise de Lotes por Vencimento"
      small
    >
      <v-icon small left>mdi-poll</v-icon>
      Análise Lotes
    </v-btn>
    <v-layout justify-center>
      <v-dialog v-model="dialog" fullscreen persistent>
        <v-card>
          <v-card-title id="titleTableValidadeLotes">
            <v-btn
              dark
              icon
              @click="dialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title class="mt-1 ml-5">
              Validade de Lotes
            </v-toolbar-title>
          </v-card-title>
          <v-card-text class="mt-3 pa-0 px-2">
            <chart-validade-lotes v-if="dialog"></chart-validade-lotes>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import ChartValidadeLotes from "../ChartValidadeLotes";

export default {
  components: {
    ChartValidadeLotes,
  },

  data: () => ({
    dialog: false,
  }),
};
</script>

<style scoped>
#titleTableValidadeLotes {
  background: #042333;
  color: #fff;
  padding: 10px;
  padding-top: 15px;
  padding-bottom: 15px;
  display: flex;
}
</style>
